<template>

  <div class="elevation-4">
    <v-toolbar flat="flat">
      <v-toolbar-title>Federations</v-toolbar-title>
    </v-toolbar>
    <v-data-table hide-headers="hide-headers" hide-actions="hide-actions" :loading="loading" :items="federations">
      <template slot="items" slot-scope="props">
        <tr>
          <td>
            <FederationLink :id="props.item.id"></FederationLink>
          </td>
        </tr>
      </template>
    </v-data-table>
  </div>

</template>

<script>

import FederationLink from '@/components/links/Federation'

export default {
  name: 'SportFederations',
  components: {
    FederationLink
  },
  props: ['id', 'loading'],
  computed: {
    federations () {
      return this.$store.getters.federationValues.filter(f => f.sportID === this.id)
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/pages/sport/SportFederations.vue